import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/explore", label: "Explore" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/quote", label: "Get a Quote" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-navy/80 border-b border-gold/20">
      <nav className="max-w-[1720px] mx-auto px-5 sm:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/logo.png?v=2" alt="Bridge Taxi, Airport Shuttle & Tours" className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/40 transition-transform duration-200 group-hover:-translate-y-0.5" />
          <span className="leading-none hidden sm:block">
            <span className="block font-heading text-lg font-bold text-white tracking-tight">Bridge Taxi</span>
            <span className="block text-[10px] uppercase tracking-[0.3em] text-gold">Airport Shuttle &amp; Tours</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 hover:text-gold ${
                loc.pathname === l.to ? "text-gold" : "text-slate-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-book-btn"
            onClick={() => nav("/book")}
            className="rounded-full bg-gold px-6 py-2.5 text-sm font-semibold text-navy transition-transform duration-200 hover:-translate-y-0.5 hover:bg-gold-light"
          >
            Book Now
          </button>
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-gold/20 bg-navy px-5 py-4 space-y-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block text-slate-200 py-3 text-base border-b border-white/5"
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-mobile-book"
            onClick={() => { setOpen(false); nav("/book"); }}
            className="w-full rounded-full bg-gold px-6 py-3.5 mt-2 text-sm font-semibold text-navy"
          >
            Book Now
          </button>
        </div>
      )}
    </header>
  );
}
